// extracted by mini-css-extract-plugin
module.exports = {"mainModal":"FilePreviewModal_mainModal__2S7y0","p_moduleBody":"FilePreviewModal_p_moduleBody__1E_Dw","Modal":"FilePreviewModal_Modal__3Jvgz"};